<template>
  <div class="bbp-tag-cell">#{{value}}</div>
</template>

<script>
import {get} from 'lodash'

export default {
  name: 'BBPTagCell',
  props: ['row', 'column', 'index'],
  computed: {
    value () {
      return get(this.row, this.column.prop, '')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-tag-cell {
    @include global-font;
    display: inline-block;
    padding: 4px 6px;
    background: $color-link-water;
    color: $color-accent;
    border-radius: 4px;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPTagCell/BBPTagCell.vue